export type InsurancePricingMode = "legacy" | "pre_discount" | "post_discount";

export function normalizeInsurancePricingMode(
    value: string | undefined | null
): InsurancePricingMode {
    const normalized = (value || "").trim().toLowerCase();

    switch (normalized) {
        case "pre_discount":
        case "prediscount":
        case "pre-discount":
        case "count_on_pre_discount":
        case "before_discount":
            return "pre_discount";
        case "post_discount":
        case "postdiscount":
        case "post-discount":
        case "count_after_discount":
        case "after_discount":
            return "post_discount";
        case "legacy":
            return "legacy";
        default:
            return "legacy";
    }
}

export interface InsuranceBaseInput {
    vehiclePrice: number;
    legacyBase: number;
    rottamazioneDiscount?: number;
    permutaDiscount?: number;
    couponDiscount?: number;
}

export function calculateInsuranceBasePrice(
    mode: InsurancePricingMode,
    input: InsuranceBaseInput
): number {
    if (mode === "legacy") {
        return Math.max(0, input.legacyBase);
    }

    if (mode === "pre_discount") {
        return Math.max(0, input.vehiclePrice);
    }

    const rottamazioneDiscount = Math.max(0, input.rottamazioneDiscount ?? 0);
    const permutaDiscount = Math.max(0, input.permutaDiscount ?? 0);
    const couponDiscount = Math.abs(Math.min(0, input.couponDiscount ?? 0));

    return Math.max(
        0,
        input.vehiclePrice - rottamazioneDiscount - permutaDiscount - couponDiscount
    );
}
